import { useState } from "react";

const LikeButton = () => {
  const [likes, setLikes] = useState(0);

  return (
    <span 
      onClick={() => setLikes(likes + 1)}
      style={{
        cursor: "pointer",
        color: likes > 0 ? "blue" : "black",
        marginTop: 4,
        marginRight: "10px",
        fontFamily: "arial",
        fontSize: 18,
        color: "darkgray",
        fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
      }}
    >
      👍 Likes {likes}
    </span>
  );
};

export default LikeButton;
